export default __webpack_public_path__ + "static/media/back-track.e559e50d.mp3";